import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import { closeDialog } from '../../store/modules/dialog';
import Button from '../common/Button';
import Dialog from './Dialog';

const DialogBody = styled.div`
  display: flex;
  height: 150px;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;

const DialogComment = styled.div`
  width: 300px;
  height: 50px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2f3133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 10px 12px 10px 12px;
`;

const PCButtonCss = css`
  min-width: 114px;
  padding-top: 5px;
  padding-bottom: 6px;
  font-weight: 700;
`;

function DropboxErrorDialog({ isShow, error }) {
  const { t } = useTranslation();
  const closeDispatch = useDispatch();
  const onClickCloseBtn = () => closeDispatch(closeDialog());

  const onMoveMainPage = () => {
    onClickCloseBtn();
    window.open('https://www.dropbox.com/home', '_self', 'noopener,noreferrer');
  };

  return (
    <Dialog isShow={isShow} isNoHeader>
      <DialogBody>
        <DialogComment title={error.message}>
          {t('DropboxErrorDialog.ErrorMessage', {
            ERROR: error.status
          })}
          <br />
          {error.message}
        </DialogComment>
        <Button primary cssExt={PCButtonCss} onClick={onMoveMainPage}>
          {t('DropboxErrorDialog.MoveDropboxHome')}
        </Button>
      </DialogBody>
    </Dialog>
  );
}

export default DropboxErrorDialog;
